import React from "react";
import Layout from "../layout/Layout";
import WhatWeOfferPage from "../components/what-we-offer/WhatWeOffer";

const WhatWeOffer = () => {
    return (
        <>
            <Layout>
                <WhatWeOfferPage />
            </Layout>
        </>
    );
};

export default WhatWeOffer;
